import type { FolderForestNode, FolderForestNodeType } from "owa-favorites-types";
import { getFolderIdForSelectedNode, getSelectedNode } from "owa-mail-folder-forest-store";
import React from "react";

export interface RetainedFolderForFavoritesSideRail {
    folderId: string;
    treeType: FolderForestNode["treeType"];
    nodeType: FolderForestNodeType;
}

export default function useRetainedFolderForFavoritesSideRail(isSideRailVisible: boolean): RetainedFolderForFavoritesSideRail | undefined {
    const retainedFolderRef = React.useRef<RetainedFolderForFavoritesSideRail | undefined>(isSideRailVisible ? getSelectedFolder() : undefined);
    const wasSideRailVisibleRef = React.useRef(isSideRailVisible);
    const isBecomingVisible = isSideRailVisible && !wasSideRailVisibleRef.current;
    const retainedFolder = !isSideRailVisible
        ? undefined
        : isBecomingVisible
            ? getSelectedFolder()
            : retainedFolderRef.current;
    
    React.useEffect(() => {
        retainedFolderRef.current = isSideRailVisible ? retainedFolder : undefined;
        wasSideRailVisibleRef.current = isSideRailVisible;
    }, [isSideRailVisible, retainedFolder]);
    
    return retainedFolder;
}

function getSelectedFolder(): RetainedFolderForFavoritesSideRail | undefined {
    const folderId = getFolderIdForSelectedNode();
    if (!folderId) {
        return undefined;
    }
    
    const selectedNode = getSelectedNode();
    return {
        folderId,
        treeType: selectedNode.treeType,
        nodeType: selectedNode.type,
    };
}
